firebird.factory('applicationDetectionService', [
    '$rootScope',
    '$resource',
    '$window',
    '$timeout',
    '$interval',
    '$location',
    'helperService',
    'logService',
    'meetingService',
    'brandingService',
    'config',
    function (
        $rootScope,
        $resource,
        $window,
        $timeout,
        $interval,
        $location,
        helperService,
        logService,
        meetingService,
        brandingService,
        config
    ) {
        const logger = logService.createLoggerWithSource('applicationDetectionService');

        const service = {
            //Properties
            launchToken: '',
            detectionState: 'checking',
            launchUrl: '',
            checkIntervalCount: 0,
            camaroAppDownloadLocation: '',
            uniteAppDownloadLocation: '',

            //Functions
            getLaunchToken: getLaunchToken,
            startLaunchDetection: startLaunchDetection,
            openUriWithMsLaunchUri: openUriWithMsLaunchUri,
            openUriWithPingCallback: openUriWithPingCallback,
            setupDownloadLocation: setupDownloadLocation,
            processSuccess: processSuccess,
            processFailure: processFailure,
            updateDetectionState: updateDetectionState
        };

        return service;

        ////////////////////////

        function getLaunchToken() {
            const target = `${helperService.getLocationProtocol()}://api.${helperService.getLocationHost()}/api/launchrequest`;
            const actions = { headers: { 'Content-Type': 'application/json' } };

            $resource(target, null)
                .get(actions)
                .$promise.then(function (data) {
                    logger.info('#getLaunchToken: success retrieving launch token');
                    service.launchToken = data.launchGuid;
                    service.startLaunchDetection();
                })
                .catch(function (err) {
                    logger.warn('#getLaunchToken: error retrieving launchToken', err);
                    service.updateDetectionState('failed');
                });
        }

        function startLaunchDetection() {
            service.launchUrl = getLaunchUrl();

            if ($window.navigator.msLaunchUri) {
                service.openUriWithMsLaunchUri(service.launchUrl, processFailure, processSuccess);
            } else {
                service.openUriWithPingCallback(service.launchUrl, processFailure, processSuccess);
            }
        }

        function getLaunchUrl() {
            const meetingUrl = `${$window.location.host}/${helperService.getRawMeetingIdentifier($location.absUrl())}`;
            const launchUrl = meetingService.getMeetingLoginUrl() || meetingUrl;
            const indexOfProtocol = launchUrl.indexOf('://') > 0 ? launchUrl.indexOf('://') + 3 : 0;
            const launchBase = brandingService.getProtocol();
            let resultedLauchUrl = launchBase + launchUrl.substring(indexOfProtocol);

            resultedLauchUrl = helperService.setQueryParameter(resultedLauchUrl, 'lnchtkn', service.launchToken);

            const attendeeResult = helperService.getQueryParameter('rslt');
            if (attendeeResult) {
                resultedLauchUrl = helperService.setQueryParameter(resultedLauchUrl, 'rslt', attendeeResult);
            }

            const hashedPassword = helperService.getQueryParameter('pwd');
            if (hashedPassword) {
                resultedLauchUrl = helperService.setQueryParameter(resultedLauchUrl, 'pwd', hashedPassword);
            }

            return resultedLauchUrl;
        }

        function openUriWithMsLaunchUri(uri, failCb, successCb) {
            logger.log('openUriWithMsLaunchUri', 'openUriWithMsLaunchUri called', uri);
            $window.navigator.msLaunchUri(
                uri,
                function () {
                    const checkUrl = `${helperService.getLocationProtocol()}://api.${helperService.getLocationHost()}/api/launchrequest/status`;
                    const params = {
                        launchGuid: service.launchToken
                    };

                    service.checkIntervalCount = 0;
                    service.checkInterval = $interval(function () {
                        service.checkIntervalCount += 1;

                        const actions = { get: { headers: { 'Content-Type': 'application/json' } } };
                        params.ts = new Date().getTime();

                        $resource(checkUrl, null, actions)
                            .get(params)
                            .$promise.then(function (data) {
                                if (data.isSuccess) {
                                    logger.log('openUriWithMsLaunchUri', 'success from msuri callback', data);
                                    $interval.cancel(service.checkInterval);
                                    successCb();
                                } else {
                                    if (service.checkIntervalCount > config.launchDetectionMaxAttemptCount) {
                                        logger.log('openUriWithMsLaunchUri', 'check interval count exceeded');
                                        $interval.cancel(service.checkInterval);
                                        failCb();
                                    }
                                }
                            })
                            .catch(function (err) {
                                logger.error('openUriWithMsLaunchUri', 'error during msuri callback', err);
                                if (service.checkIntervalCount > config.launchDetectionMaxAttemptCount) {
                                    $interval.cancel(service.checkInterval);
                                    failCb();
                                }
                            });
                    }, 2000);
                },
                failCb
            );
        }

        function getHiddenFrame() {
            return (
                $window.document.querySelector('#hiddenIframe') ||
                _createHiddenIframe($window.document.body, 'about:blank')
            );
        }

        function openUriWithPingCallback(uri, failCb, successCb) {
            logger.info('#openUriWithPingCallback: openUriWithPingCallback called', uri);
            const checkUrl = `${helperService.getLocationProtocol()}://api.${helperService.getLocationHost()}/api/launchrequest/status`;
            const params = {
                launchGuid: service.launchToken
            };

            $window.focus();
            const iframe = getHiddenFrame();
            iframe.contentWindow.location.href = uri;

            service.checkIntervalCount = 0;
            service.checkInterval = $interval(function () {
                service.checkIntervalCount += 1;

                const actions = { get: { headers: { 'Content-Type': 'application/json' } } };
                params.ts = new Date().getTime();

                $resource(checkUrl, null, actions)
                    .get(params)
                    .$promise.then(function (data) {
                        if (data.isSuccess) {
                            logger.info('#openUriWithPingCallback: success from ping callback', data);
                            $interval.cancel(service.checkInterval);
                            successCb();
                        } else {
                            if (service.checkIntervalCount > config.launchDetectionMaxAttemptCount) {
                                logger.debug('#openUriWithPingCallback: check interval count exceeded', data);
                                $interval.cancel(service.checkInterval);
                                failCb();
                            }
                        }
                    })
                    .catch(function (err) {
                        logger.error('#openUriWithPingCallback: error during ping callback', err);
                        if (service.checkIntervalCount > config.launchDetectionMaxAttemptCount) {
                            $interval.cancel(service.checkInterval);
                            failCb();
                        }
                    });
            }, 2000);
        }

        function setupDownloadLocation() {
            let lastPath = '';
            const isMacOs = helperService.isMac();
            const isWin = helperService.isWindows();

            if (isMacOs) {
                lastPath = 'osx';
            } else if (isWin) {
                lastPath = 'win';
            } else {
                //TODO: unsupported platform shouldn't be allowed to get here
                logger.warn('setupDownloadLocation', 'unsupported platform');
            }

            service.uniteAppDownloadLocation = brandingService.getUniteDownloadLink();
            service.camaroAppDownloadLocation = `https://www.${helperService.getLocationHost()}/downloads/desktop/latest/${lastPath}`;
        }

        function processSuccess() {
            $('body > #loading-bar-spinner').show(); //put the loading spinner back
            logger.log('processSuccess', 'processSuccess fired.  app detected');
            service.updateDetectionState('success');
        }

        function processFailure() {
            if (!helperService.isChrome()) {
                $('body > #loading-bar-spinner').show(); //put the loading spinner back
                logger.log('processFailure', 'processFailure fired.  app not detected');
            }
            service.updateDetectionState('failed');
        }

        function updateDetectionState(newDetectionState) {
            service.detectionState = newDetectionState;
            $rootScope.$broadcast('camaro-detection-state-updated', newDetectionState);
        }

        function _createHiddenIframe(target, uri) {
            const iframe = $window.document.createElement('iframe');
            iframe.src = uri;
            iframe.id = 'hiddenIframe';
            iframe.style.display = 'none';
            target.appendChild(iframe);

            return iframe;
        }

        function _registerEvent(target, eventType, cb) {
            if (target.addEventListener) {
                target.addEventListener(eventType, cb);
                return {
                    remove: function () {
                        target.removeEventListener(eventType, cb);
                    }
                };
            } else {
                target.attachEvent(eventType, cb);
                return {
                    remove: function () {
                        target.detachEvent(eventType, cb);
                    }
                };
            }
        }
    }
]);
